<template>
  <div>
    <div class="layout-with-centered-max-width-child">
      <div>
        <div v-if="loadingStarted">
          <loading></loading>
        </div>
        <div v-else-if="loadingSuccessful">
          <div class="browse-container">
            <div class="font-secondary heading">browse studies</div>
            <div class="search-container each-row">
              <Search v-on:input="updateSearchQuery" :search="search"></Search>
            </div>
            <div class="dropdown-container each-row">
              <div class="sort-by">Sort by:</div>
              <Dropdown :selection=searchParams.order>
                <div class="option" v-for="orderOption in orderByOptions" @click="setOrderBy(orderOption)">
                  <span class="options-text">{{orderOption}}</span>
                </div>
              </Dropdown>
            </div>
            <div v-if="resultsLoadingStarted">
              <loading></loading>
            </div>
            <div v-else-if="resultsLoadingSuccessful">
              <div>
                <div v-for="study in studies" class="each-row">
                  <div v-on:click="loadSurvey(study)" class="clickable">
                    <StudyCard :study="study"></StudyCard>
                  </div>
                </div>
              </div>
              <div class="each-row">
                <div class="centered-row">
                  <span class="pagination" v-bind:class="page.optional" v-for="page in pages" @click="setPageNumber(page)">{{page.pageNumber}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="loadingFailed">
          <div class="centered-row">
            <ErrorPage>
              <div slot="header">ERROR</div>
              <div slot="message">Sorry, there was an error loading the page</div>
            </ErrorPage>
          </div>
        </div>
      </div>
    </div>
  </div>
    
</template>

<script>
    import Search from "../general/Search"
    import Dropdown from "../general/Dropdown"
    import {
      LOADING_STARTED,
      LOADING_COMPLETED_FAILURE,
      LOADING_COMPLETED_SUCCESS,
      GET_BACKEND_URL, GET_HTTP_CONFIG,
    } from "../../services/constants"
    import http from "../../services/axios"
    import ErrorPage from "./ErrorPage"
    import StudyCard from "./StudyCard"
    export default {
        name: "Browse",
        components: {StudyCard, ErrorPage, Dropdown, Search},

        created(){
          this.updateSearchParams()
          this.updateBrowseComponent()
        },

        data(){
          return{
            loadingStatus: LOADING_STARTED,
            resultsLoadingStatus: LOADING_STARTED,
            studies: [],
            numberOfPages: 1,
            searchParams:{
              order: 'Name',
              q: '',
              p: '1',
            }
          }
        },

      watch: {
        '$route'(nv, ov){
          this.updateSearchParams()
          this.updateBrowseComponent()
        }
      },

      computed: {
        loadingStarted(){
          return this.loadingStatus === LOADING_STARTED
        },
        resultsLoadingStarted(){
          return this.resultsLoadingStatus === LOADING_STARTED
        },
        resultsLoadingSuccessful(){
          return this.resultsLoadingStatus === LOADING_COMPLETED_SUCCESS
        },
        orderByOptions(){
          return ['Name', 'Date Created', 'Number of Participants']
        },
        loadingSuccessful(){
          return this.loadingStatus === LOADING_COMPLETED_SUCCESS
        },
        loadingFailed(){
          return this.loadingStatus === LOADING_COMPLETED_FAILURE
        },
        orderParam(){
          return this.formatOrderByOptions(this.searchParams.order)
        },
        pages(){
          return [...Array(this.numberOfPages).keys()].map((number) => {
              return{
                pageNumber: number+1,
                optional: {'optional': number+1 === this.searchParams.p}
              }
          })

        },

      },

        methods:{
          setOrderBy(orderOption){
            if(this.orderParam !== this.formatOrderByOptions(orderOption)){
              this.resultsLoadingStatus = LOADING_STARTED
              this.searchParams.order = orderOption
              this.$router.push({ query: this.buildParams()})
            }
          },
          search(){
            this.resultsLoadingStatus = LOADING_STARTED
            this.$router.push({ query: this.buildParams()})
          },
          buildParams(){
            let params = {
              'order': this.orderParam,
              'p': this.searchParams.p,
              'q': this.searchParams.q}
            return params
          },
          updateSearchParams(){
            let queryParams = Object.assign({}, this.$route.query)
            if ('order' in queryParams){
              queryParams['order'] = this.reverseFormatOrderByOptions(queryParams['order'])
            }
            this.searchParams = Object.assign({}, this.searchParams, queryParams)
          },
          updateBrowseComponent(){
            let params = this.buildParams()
            http.get(this.$store.getters[GET_BACKEND_URL](`studies/browse?`), {'params': params}, this.$store.getters[GET_HTTP_CONFIG]).then(response => {
                this.studies = response.data.studySummaries
                this.searchParams.p = response.data.currentPage
                this.numberOfPages = response.data.totalPages
                this.loadingStatus = LOADING_COMPLETED_SUCCESS
                this.resultsLoadingStatus = LOADING_COMPLETED_SUCCESS
              })
              .catch(err =>{
                console.log(err)
                this.loadingStatus = LOADING_COMPLETED_FAILURE
              })
          },
          updateSearchQuery(evt){
            this.searchParams.q = evt
          },
          setPageNumber(page){
            this.resultsLoadingStatus = LOADING_STARTED
            this.searchParams.p = page.pageNumber
            this.$router.push({ query: this.buildParams()})
          },
          reverseFormatOrderByOptions(param){
            for (let orderBy in this.orderByOptions) {
              if(param === this.formatOrderByOptions(this.orderByOptions[orderBy])){
                return this.orderByOptions[orderBy]
              }
            }
          },
          formatOrderByOptions(orderBy){
            return orderBy.toUpperCase().split(" ").join("_")
          },
          loadSurvey(study){
            this.$router.push(`study/${study.id}`)
          },

        }
    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .heading{
    color: $red-2;
    font-weight: bold;
    font-size: 17px;
    margin-top: 45px;
    margin-bottom: 25px;
  }

  .sort-by{
    padding-bottom: 3%;
    color: $red-2;
  }

  .options-text{
    font-size: 16px;
  }

  .browse-container{
    margin: 0 60px;
  }

  .search-container{
    width: 50%;
    @media #{$mobile} {
      width: 100%;
    }
  }

  .dropdown-container{
    width: 33%;
    @media #{$mobile} {
      width: 100%;
    }
  }

  .each-row{
    padding: 2% 0;
  }

  .option {
    padding: 5px 20px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  .option:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .clickable:hover{
    cursor: pointer;
  }

  .pagination{
    padding: 0 5px;
    &.optional{
      text-decoration: underline;
    }
    &:hover{
      cursor: pointer;
    }
  }

</style>
